import React from 'react';
import {
    Grid,
    Typography,
    Divider,
    IconButton,
    Button,
} from '@material-ui/core';
import { CustomTextField, StyledMenuItem } from '../../../../Textfield';
import DeleteIcon from '@material-ui/icons/Delete';

const ClientInfoComponent = ({ formik, handlers, clientList }) => (
    <Grid item container spacing={2} style={{}}>
        <Grid item xs={12}>
            <Typography
                style={{
                    fontSize: '18px',
                    fontWeight: 600,
                    marginBottom: '18px',
                }}
                variant="body1"
            >
                Other Info
            </Typography>
            <Divider />
        </Grid>
        {!!formik?.values?.clients?.length &&
            formik?.values?.clients?.map((customer, index) => (
                <>
                    <Grid item xs={6} key={'customer-' + index}>
                        <CustomTextField
                            key={'customer-input-' + index}
                            label="Client Name"
                            select
                            isRequired={true}
                            fullWidth={true}
                            value={customer.customerId ?? ''}
                            onChange={(e) =>
                                handlers.updateClient(
                                    index,
                                    'customerId',
                                    e.target.value,
                                )
                            }
                            name={'customerId'}
                            defaultValue=""
                            style={{
                                marginBottom: '16px',
                                width: '100%',
                                marginRight: 5,
                            }}
                            error={
                                formik.touched.clients?.customerId &&
                                Boolean(formik.errors.clients?.customerId)
                            }
                            helperText={
                                formik.touched.clients?.customerId &&
                                formik.errors.clients?.customerId
                            }
                        >
                            {clientList?.length === 0 && (
                                <StyledMenuItem value={null}>
                                    No Data Found
                                </StyledMenuItem>
                            )}
                            {clientList?.map((cust, index) => (
                                <StyledMenuItem
                                    key={index}
                                    value={cust?.customerId}
                                >
                                    {cust?.name}
                                </StyledMenuItem>
                            ))}
                        </CustomTextField>
                    </Grid>
                    <Grid
                        item
                        xs={5}
                        key={'customer-ref-' + index}
                        direction={'row'}
                    >
                        <CustomTextField
                            key={'customer-ref-input' + index}
                            fullWidth={true}
                            label="Staff Reference Number"
                            value={customer?.staffCustCode}
                            name={'staffCustCode'}
                            isRequired={true}
                            onChange={(e) =>
                                handlers.updateClient(
                                    index,
                                    'staffCustCode',
                                    e.target.value,
                                )
                            }
                            error={
                                formik.touched.clients?.staffCustCode &&
                                Boolean(formik.errors.clients?.staffCustCode)
                            }
                            helperText={
                                formik.touched.clients?.staffCustCode &&
                                formik.errors.clients?.staffCustCode
                            }
                            style={{ marginBottom: '16px' }}
                        />
                    </Grid>
                    <Grid item xs={1} key={'customer-delete' + index}>
                        <IconButton
                            aria-label="delete"
                            icon={'close'}
                            onClick={() => {
                                handlers.removeClient(index);
                            }}
                        >
                            <DeleteIcon color="error" />
                        </IconButton>
                    </Grid>
                </>
            ))}
        <Grid
            item
            xs={12}
            style={{ paddingTop: '12px', paddingBottom: '24px' }}
        >
            <Button
                key={'add-client'}
                variant="contained"
                color="primary"
                className={`saveButton`}
                onClick={handlers.addClient}
                disableElevation
            >
                {'Add Client'}
            </Button>
            {/* <Divider /> */}
        </Grid>
    </Grid>
);

export default ClientInfoComponent;
